<template>
    <mdb-footer class="border-top font-small mt-4 pt-4" style="background-color: #f7f9fb">
        <mdb-container class="text-center text-md-left text-dark">
            <mdb-row class="text-center text-md-left mt-3 pb-3">
                <hr class="w-100 clearfix d-md-none"/>
                <mdb-col md="2" lg="2" xl="2" class="mx-auto mt-3">
                    <h6 class="text-uppercase mb-4 font-weight-bold">{{ msg.navigation }}</h6>
                    <p><router-link to="/websites" class="text-dark">{{ msg.websites }}</router-link></p>
                    <p><router-link to="/mobileapps" class="text-dark">{{ msg.mobileapps }}</router-link></p>
                    <p><router-link to="/maintenance" class="text-dark">{{ msg.maintenance }}</router-link></p>
                </mdb-col>
                <hr class="w-100 clearfix d-md-none"/>
                <mdb-col md="2" lg="2" xl="2" class="mx-auto mt-3">
                    <h6 class="text-uppercase mb-4 font-weight-bold">&nbsp;</h6>
                    <p><router-link to="/story" class="text-dark">{{ msg.story }}</router-link></p>
                    <p><router-link to="/contact" class="text-dark">{{ msg.contact }}</router-link></p>
                    <p><router-link to="/privacy" class="text-dark">{{ msg.privacy }}</router-link></p>
                </mdb-col>
                <hr class="w-100 clearfix d-md-none"/>
                <mdb-col md="2" lg="2" xl="2" class="mx-auto mt-3" />
                <!--<mdb-col md="2" lg="2" xl="2" class="mx-auto mt-3">
                    <h6 class="text-uppercase mb-4 font-weight-bold">{{ msg.solutions }}</h6>
                    <p><router-link to="/hosting" class="text-dark">Hosting</router-link></p>
                </mdb-col>-->
                <hr class="w-100 clearfix d-md-none"/>
                <mdb-col md="4" lg="3" xl="3" class="mx-auto mt-3">
                    <h6 class="text-uppercase mb-4 font-weight-bold">{{ msg.contact }}</h6>
                    <p><i class="fas fa-home mr-3"></i> Oulu, Finland</p>
                    <p><i class="fas fa-envelope mr-3"></i> me@arttupesonen.fi</p>
                    <p><i class="fas fa-phone mr-3"></i>+358 44 212 9464</p>
                </mdb-col>
            </mdb-row>
            <hr/>
            <mdb-row class="d-flex align-items-center justify-content-center">
                <p class="text-center text-md-left text-dark">&copy; 2019 Verkkolabra</p>
            </mdb-row>
        </mdb-container>
    </mdb-footer>
</template>

<script>
    import {mdbFooter, mdbContainer, mdbRow, mdbCol} from 'mdbvue';
    import { lang } from './../language';

    export default {
        name: 'Footer',
        components: {
            mdbFooter,
            mdbContainer,
            mdbRow,
            mdbCol
        },
        data() {
            return {
                msg: null,
            }
        },
        created() {
            this.msg = lang.app.nav;
        },
    }
</script>